import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function MainCTA() {
  return <section className="bg-azul-noche py-24 px-6 text-center relative overflow-hidden" data-id="element-233">
      {/* Decorative stars */}
      <div className="absolute top-10 left-1/4 opacity-30" data-id="element-234">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C9B8E8" strokeWidth="2" data-id="element-235">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-236" />
        </svg>
      </div>
      <div className="absolute bottom-20 right-1/4 opacity-30" data-id="element-237">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#C9B8E8" strokeWidth="2" data-id="element-238">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-239" />
        </svg>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-240">
        <FadeIn data-id="element-241">
          <div className="flex justify-center mb-8" data-id="element-242">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#C9B8E8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-243">
              <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" data-id="element-244" />
              <path d="M19 3v4" data-id="element-245" />
              <path d="M21 5h-4" data-id="element-246" />
            </svg>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-247">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" data-id="element-248">
            ¿Cuántas noches más sin dormir tiene sentido esperar?
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-249">
          <p className="text-xl text-crema mb-12" data-id="element-250">
            Esta noche puede ser diferente.
            <br data-id="element-251" />
            No perfecta. No mágica. Pero diferente — porque por primera vez vas
            a saber exactamente qué hacer y por qué funciona.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-252">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-lila-suave text-azul-noche font-bold text-xl px-10 py-5 rounded-full shadow-[0_0_30px_rgba(201,184,232,0.3)] hover:shadow-[0_0_40px_rgba(201,184,232,0.5)] transition-shadow w-full sm:w-auto mb-8" data-id="element-253">
            Quiero Que Mi Bebé Duerma Más Esta Semana →
          </motion.button>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-254">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/80" data-id="element-255">
            <div className="flex items-center gap-2" data-id="element-256">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-257">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-258"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-259"></path>
              </svg>
              <span data-id="element-260">Pago Seguro</span>
            </div>
            <div className="hidden sm:block text-white/30" data-id="element-261">•</div>
            <div className="flex items-center gap-2" data-id="element-262">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-263">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-264"></path>
              </svg>
              <span data-id="element-265">Garantía 30 días</span>
            </div>
            <div className="hidden sm:block text-white/30" data-id="element-266">•</div>
            <div className="flex items-center gap-2" data-id="element-267">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-268">
                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" data-id="element-269"></path>
                <polyline points="13 2 13 9 20 9" data-id="element-270"></polyline>
              </svg>
              <span data-id="element-271">Acceso Inmediato</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}